import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import ForbiddenScreen from "../screens/ForbiddenScreen";

const StaffRoute = () => {
  const { userInfo } = useSelector((state) => state.auth);
  if (!userInfo) return <Navigate to="/login" replace />;

  const dept = (userInfo.primaryDepartment || '').toUpperCase();
  const allowed = userInfo.isAdmin || userInfo.isStaff || !!dept;

  if (!allowed) return <ForbiddenScreen required="staff" />;
  return <Outlet />;
};

export default StaffRoute;
